module.exports = __webpack_public_path__ + "img/offline-status.038c380c.svg";